import { render, staticRenderFns } from "./SizeChartModal.vue?vue&type=template&id=2ca8af75&scoped=true&"
import script from "./SizeChartModal.vue?vue&type=script&lang=js&"
export * from "./SizeChartModal.vue?vue&type=script&lang=js&"
import style0 from "./SizeChartModal.vue?vue&type=style&index=0&id=2ca8af75&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca8af75",
  null
  
)

export default component.exports